import { render, staticRenderFns } from "./CollageCircuits.vue?vue&type=template&id=dfcdbc26&"
import script from "./CollageCircuits.vue?vue&type=script&lang=js&"
export * from "./CollageCircuits.vue?vue&type=script&lang=js&"
import style0 from "./CollageCircuits.vue?vue&type=style&index=0&id=dfcdbc26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports